export default "__VITE_ASSET__sJIeM7hgG3OfUlyD3$43gw__";